import React from 'react';

import AudioInputList from './AudioInputList/AudioInputList';
import {
  DialogContent,
  Typography,
  Divider,
  Dialog,
  DialogActions,
  Theme,
  DialogTitle,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import VideoInputList from './VideoInputList/VideoInputList';
import {Button, Modal} from "react-bootstrap";
import {$$} from "../../../helpers/localization";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '600px',
    minHeight: '400px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  button: {
    float: 'right',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  headline: {
    marginBottom: '1.3em',
    fontSize: '1.1rem',
  },
  listSection: {
    margin: '2em 0 0.8em',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },
}));

export default function DeviceSelectionDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const classes = useStyles();

  return (
    <div>
      <h4>{$$("audio_and_video_settings")}</h4>
      <div >
        <div className={classes.listSection}>
          <Typography variant="h6" className={classes.headline}>
            {$$("video")}
          </Typography>
          <VideoInputList />
        </div>
        <Divider />
        <div className={classes.listSection}>
          <Typography variant="h6" className={classes.headline}>
            {$$("audio")}
          </Typography>
          <AudioInputList />
        </div>
      </div>
      <div>
        <Button variant="success" className={classes.button} onClick={onClose}>
          {$$("done_btn")}
        </Button>
      </div>
    </div>
  );
}
